'use strict';

import React, {useEffect, useState} from 'react';
import Notification from '../../Notification';
import get from "lodash/get";
import {FormattedMessage} from "react-intl";
import {formatCustom, getTime} from "../../../utils/TimeUtils";
import Loader from "../../Loader";
import {getDepartmentDisplay} from "../../../utils/TimelineUtils";
import OTIcon from "../../tag/OTIcon";
import Row from "../../tag/Row";
import OTButtonGroup from "../../tag/OTButtonGroup";
import OTButton from "../../tag/OTButton";
import {FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION} from "../../../definitions/NotificationConstants";
import { doRequestDismissNotifications } from '../../../data/notification/actions';
import { useHistory } from 'react-router-dom';
import {connect, useSelector} from "react-redux";
import {QUESTIONNAIRES} from "../../../data/reducer";
import Api from "../../../api/Api";
import {timelineSelector} from "../../../data/selector";
import {determineAndAddType} from "../../../views/timeline/data/selector";
import {getDescriptionTypeFromTimelineEventForAssignedForm} from "../../../utils/FormulaUtils";

const { id: module_id } = module;

function FormulaNotification(props) {
    const {
        showActiveQuestionnaireDescription,
        data,
        doRequestDismissNotifications,
        formConfigs
    } = props;

    const { appointmentData } = data;
    const history = useHistory();

    let [formConfig, setFormConfig] = useState(null);
    let [relatedTimelineEvent, setRelatedTimelineEvent] = useState(null);

    const { data: timelineData } = useSelector(timelineSelector);

    useEffect(() =>{
        if (timelineData && data) {
            let foundRelatedTimelineEvent = timelineData.find(
                (timelineEvent) => timelineEvent.id === data.timelineEventId
            );
            if (foundRelatedTimelineEvent) {
                foundRelatedTimelineEvent = determineAndAddType(foundRelatedTimelineEvent);
                setRelatedTimelineEvent(foundRelatedTimelineEvent);
            }
        }
    }, [data, timelineData]);

    useEffect(() => {
        if (formConfigs && formConfigs[0]?._id) {
            let foundConfig = formConfigs?.find(
                (config) => config._id === parseInt(data.formulaFormId.split('_')[1])
            );
            setFormConfig(foundConfig);
        }
    }, [formConfigs])

    let endDateTime = get(data, 'endDate', null) ? (
        <FormattedMessage
            id={`${module_id}.fill.at.the.latest`}
            values={{
                date: getTime(data.endDate).format('D.M.YYYY'),
            }}
        />
    ) : null;

    let description = null;

    if (!showActiveQuestionnaireDescription) {
        description = <Loader style={{ margin: '40px auto' }} />;
    } else {
        if (appointmentData) {
            const descriptionType = getDescriptionTypeFromTimelineEventForAssignedForm(relatedTimelineEvent);
            description = (
                <FormattedMessage
                    id={`${module_id}.fill.questionnaire.with.appointment`}
                    values={{
                        name: data.title,
                        department: getDepartmentDisplay(appointmentData.department),
                        date: formatCustom(appointmentData.date, 'D.M.YYYY'),
                        time: formatCustom(appointmentData.date, 'H.mm'),
                        descriptiontype: descriptionType,
                        strong: (chunks) => <strong>{chunks}</strong>,
                        strongSemibold: (chunks) => (
                            <strong className="semibold">{chunks}</strong>
                        ),
                    }}
                />
            );
        } else {
            description = (
                <FormattedMessage
                    id={`${module_id}.fill.questionnaire`}
                    values={{ name: data.title }}
                />
            );
        }
    }

    const fillClicked = () => {
        doRequestDismissNotifications(`${FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION}_${data.id}`);
        if ( data.questionnaireOpened === null || data.questionnaireOpened === false ) {
          data.questionnaireOpened = true;
          Api.updateFormAssignment(data);
        }

        history.push(`/questionnaires/response/${data.formulaFormId}/${data.formResponseId}`);
    }

    return (
        <Notification>
            <OTIcon
                config={{ type: 'custom', name: 'kyselyt', color: 'darkblue' }}
                style={{ width: '17px', marginRight: '20px' }}
            />
            <h2 className="ot-notification__header">
                <FormattedMessage id={`${module_id}.new.questionnaire`} />
            </h2>
            {<div className="ot-notification__description">{description}</div>}
            {data.infoText && (
                <div className="ot-notification__description">
                    <OTIcon
                        config={{ type: 'custom', name: 'palaute', color: 'darkblue' }}
                        style={{ marginRight: '5px', height: '15px' }}
                    />
                    {data.infoText}
                </div>
            )}
            <div className="ot-notification__description">
                {endDateTime}
                <br />
                <FormattedMessage id={`${module_id}.info.questionnaire`} />
            </div>
            <Row>
                <div className="ot-notification__buttonrow">
                    <OTButtonGroup
                        collapseOnMobile
                        formulaButton
                        expectedCount={2}
                        fullWidth
                        type="big"
                    >
                        <OTButton
                            className="ot-notification__button"
                            onClick={fillClicked}
                        >
                            <FormattedMessage id={`fill`} />
                        </OTButton>
                        <OTButton
                            onClick={ () =>
                                doRequestDismissNotifications(`${FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION}_${data.id}`)
                            }
                        >
                            <FormattedMessage id={'fill.later'} />
                        </OTButton>
                    </OTButtonGroup>
                </div>
                {formConfig?.logo && (
                    <img
                        src={formConfig?.logo}
                        className={'ot-form-logo'}
                        alt={'logo'}
                        style={{
                            float: 'right',
                            maxWidth: '120px',
                            maxHeight: '32px',
                            padding: '0',
                            paddingTop: '2px',
                            marginRight: '-4px'
                        }}
                    />
                )}
            </Row>
        </Notification>
    );
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        doRequestDismissNotifications: (notificationId) =>
            dispatch(doRequestDismissNotifications([notificationId]))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormulaNotification);

